import { render } from "./TodayComponent.vue?vue&type=template&id=2510a14d&scoped=true"
import script from "./TodayComponent.vue?vue&type=script&lang=js"
export * from "./TodayComponent.vue?vue&type=script&lang=js"

import "./TodayComponent.vue?vue&type=style&index=0&id=2510a14d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2510a14d"]])

export default __exports__